import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic, rank }: { comic: Comic; rank?: number }) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block"
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100">
        <div className="aspect-[3/4] overflow-hidden">
          <img
            src={comic.cover}
            alt={comic.title}
            title={`${comic.title} - 4399漫画网韩国漫画`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        {rank && (
          <div className="absolute top-2 left-2 w-7 h-7 rounded-full bg-primary-500 text-background-50 text-xs font-bold flex items-center justify-center">
            {rank}
          </div>
        )}
        {comic.status === "已完结" && (
          <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
            完结
          </div>
        )}
        {comic.status === "连载中" && (
          <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
            连载
          </div>
        )}
      </div>
      <div className="mt-3 px-0.5">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-400">{comic.author}</span>
          <span className="text-xs text-foreground-300">·</span>
          <span className="text-xs text-foreground-400">{comic.chapters}话</span>
        </div>
        <div className="flex items-center gap-1 mt-1">
          <i className="ri-star-fill text-accent-500 text-xs"></i>
          <span className="text-xs text-foreground-500">{comic.rating}</span>
          <span className="text-xs text-foreground-300 ml-auto">
            {comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}阅
          </span>
        </div>
      </div>
    </Link>
  );
}